import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Picture} from "@pg-design/picture-module";
import {propertyOffer} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../../../tracking/amplitude/track_amplitude_button_click";
import {useOffersViewsUrl} from "../../../../hooks/use_offers_views_url";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../../helpers/offer_listing_amplitude_item_list_id";
import {GTMEventAction, hitGtmMapCtaEvent} from "../../../tracking/gtm_map_cta_event";

const mapCtaBackgroundDesktopImage = require("../../../../images/mid_listing_banners/map_cta_background_desktop.jpg");
const mapCtaBackgroundMobileImage = require("../../../../images/mid_listing_banners/map_cta_background_mobile.jpg");

interface IProps {
    id: string;
    offerCount: number | null;
    className?: string;
}

export const MidListingMapBanner = (props: IProps) => {
    const {mapUrl} = useOffersViewsUrl();
    const latestQuery = useAppSelector((state) => state.offerList.list.latestQuery);

    if (!props.offerCount) {
        return null;
    }

    const onMapCtaBtnClick = () => {
        hitGtmMapCtaEvent(GTMEventAction.CLICK);
        trackAmplitudeButtonClick({
            buttonName: "view_map",
            buttonCategory: "listing_page",
            value: "see_on_map",
            itemId: null,
            buttonLink: null,
            itemListId: getOrCreateOfferListingAmplitudeItemListId(latestQuery)
        });
    };

    return (
        <a onClick={onMapCtaBtnClick} href={mapUrl}>
            <div data-id={props.id} className={wrapperStyle}>
                <Picture
                    className={pictureStyle}
                    sources={[
                        {minWidthPX: 0, src: mapCtaBackgroundMobileImage, height: 224, width: 740},
                        {minWidthPX: 600, src: mapCtaBackgroundDesktopImage, height: 224, width: 1536}
                    ]}
                    fit="cover"
                    alt="picture"
                />
                <Button variant="filled_secondary" className={buttonStyle}>
                    Zobacz {props.offerCount} {propertyOffer.accusative(props.offerCount)} na mapie
                </Button>
            </div>
        </a>
    );
};

const wrapperStyle = css({
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 2,
    boxShadow: "var(--shadow-2)",
    height: "24rem",
    width: "100%",
    maxWidth: "37.5rem",
    overflow: "hidden",
    md: {
        height: "22.5rem",
        maxWidth: "100%"
    }
});

const pictureStyle = css({
    display: "flex",
    alignItems: "normal",
    justifyContent: "center",
    userSelect: "none",
    pointerEvents: "none"
});

const buttonStyle = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Picture} from "@pg-design/picture-module";
import {propertyOffer} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../../../tracking/amplitude/track_amplitude_button_click";
import {useOffersViewsUrl} from "../../../../hooks/use_offers_views_url";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../../helpers/offer_listing_amplitude_item_list_id";
import {GTMEventAction, hitGtmMapCtaEvent} from "../../../tracking/gtm_map_cta_event";

const mapCtaBackgroundDesktopImage = require("../../../../images/mid_listing_banners/map_cta_background_desktop.jpg");
const mapCtaBackgroundMobileImage = require("../../../../images/mid_listing_banners/map_cta_background_mobile.jpg");

interface IProps {
    id: string;
    offerCount: number | null;
    className?: string;
}

export const MidListingMapBanner = (props: IProps) => {
    const {mapUrl} = useOffersViewsUrl();
    const latestQuery = useAppSelector((state) => state.offerList.list.latestQuery);

    if (!props.offerCount) {
        return null;
    }

    const onMapCtaBtnClick = () => {
        hitGtmMapCtaEvent(GTMEventAction.CLICK);
        trackAmplitudeButtonClick({
            buttonName: "view_map",
            buttonCategory: "listing_page",
            value: "see_on_map",
            itemId: null,
            buttonLink: null,
            itemListId: getOrCreateOfferListingAmplitudeItemListId(latestQuery)
        });
    };

    return (
        <a onClick={onMapCtaBtnClick} href={mapUrl}>
            <div data-id={props.id} className={wrapperStyle}>
                <Picture
                    className={pictureStyle}
                    sources={[
                        {minWidthPX: 0, src: mapCtaBackgroundMobileImage, height: 224, width: 740},
                        {minWidthPX: 600, src: mapCtaBackgroundDesktopImage, height: 224, width: 1536}
                    ]}
                    fit="cover"
                    alt="picture"
                />
                <Button variant="filled_secondary" className={buttonStyle}>
                    Zobacz {props.offerCount} {propertyOffer.accusative(props.offerCount)} na mapie
                </Button>
            </div>
        </a>
    );
};

const wrapperStyle = css({
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 2,
    boxShadow: "var(--shadow-2)",
    height: "24rem",
    width: "100%",
    maxWidth: "37.5rem",
    overflow: "hidden",
    md: {
        height: "22.5rem",
        maxWidth: "100%"
    }
});

const pictureStyle = css({
    display: "flex",
    alignItems: "normal",
    justifyContent: "center",
    userSelect: "none",
    pointerEvents: "none"
});

const buttonStyle = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
});
